import vm from '@/business/main'
import Bussiness from 'Utils/business'

/**
 * 火车票改签单类
 * @param {Object} detail 火车订单详
 */

export default {
  /**
   * 取消改签
   */
  async cancel (detail) {
    await vm.$dialog.confirm({
      message: '您确定要取消改签吗？',
    }).then(async () => {
      try {
        await vm.$api['trOrder/cancelTrChangeOrder']({ changeId: detail.id })
        return true
      } catch (res) {
        return res
      }
    })
  },
  /**
   * 改签支付
   */
  pay (detail) {
    vm.$router.push({
      path: '/pay/payment',
      query: {
        orderId: detail.id,
        orderType: detail.orderType
      }
    })
  },
  /**
   * 送审
   */
  approval (detail) {
    detail.orderType = $dict.ORDER_TYPE.tr.change
    Bussiness.ApprovalSend(detail)
  },
  /**
   * 确认改签
   */
  async confirmChange (detail) {
    await vm.$dialog.confirm({
      message: '您确定要改签吗？',
    }).then(async () => {
      try {
        await vm.$api['trOrder/confirmTrChangeOrder']({changeId: detail.id})
        return vm.$dialog.alert({ message: '已经申请确认改签！' })
      } catch (res) {
        return res
      }
    })
  },
  /**
   * 退票
   */
  refund (detail) {
    if (!Bussiness.DetectorNearTime(detail, 'refund')) {
      return false
    } else {
      vm.$dialog.confirm({
        message: '如已打印纸质车票，只能去车站办理退改！未打印纸质车票，可以线上提交办理。'
      }).then(() => {
        vm.$router.push({ path: '/tr/ApplyRefund', query: {
          id: detail.changeId || detail.id,
          applyType: '1'
        }})
      })
    }
  }
}